import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ShoppingCart, Star } from "lucide-react";

const Toggle = ({ on, onClick, testid, label }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`h-10 px-3 text-[11px] uppercase tracking-wider font-bold border ${on ? "bg-[#059669] text-white border-[#059669]" : "bg-white text-[#868E96] border-[#DEE2E6]"}`}>
    {on ? "✓ " : "✗ "}{label}
  </button>
);

const HOURS = Array.from({ length: 24 }, (_, h) => h);
const DELAYS = [1, 2, 3, 6, 12, 24, 48, 72];

// Phase 55 (relance panier) + Phase 56 (avis après séjour) — réglages dans Réservations › Réglages
export function ReservationAutomations({ cfg, setCfg }) {
  return (
    <>
      <div className="mt-5 border-t border-[#DEE2E6] pt-4" data-testid="cr-cfg-cart">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] flex items-center gap-1 mb-2">
          <ShoppingCart className="h-3 w-3" />Relance panier abandonné
        </div>
        <div className="flex flex-wrap items-end gap-3">
          <Toggle on={cfg.cart_reminder_enabled !== false} testid="cr-cfg-cart-enabled" label="Email de relance"
            onClick={() => setCfg((c) => ({ ...c, cart_reminder_enabled: c.cart_reminder_enabled === false }))} />
          <div>
            <Label className="text-[10px] uppercase tracking-wider">Délai après l'abandon</Label>
            <Select value={String(cfg.cart_reminder_delay_hours ?? 3)} onValueChange={(v) => setCfg({ ...cfg, cart_reminder_delay_hours: parseInt(v) })}>
              <SelectTrigger className="w-[130px]" data-testid="cr-cfg-cart-delay"><SelectValue /></SelectTrigger>
              <SelectContent>{DELAYS.map((h) => <SelectItem key={h} value={String(h)}>{h} h</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <div className="text-[11px] text-[#495057] mt-2">
          Un client qui a commencé une réservation <b>payable en ligne</b> (carte ou PayPal) sans finaliser le paiement reçoit
          <b> un seul email</b> après ce délai, avec un bouton qui régénère un lien de paiement à jour. Aucun SMS.
        </div>
      </div>

      <div className="mt-5 border-t border-[#DEE2E6] pt-4" data-testid="cr-cfg-review">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] flex items-center gap-1 mb-2">
          <Star className="h-3 w-3" />Avis après séjour
        </div>
        <div className="flex flex-wrap items-end gap-3">
          <Toggle on={cfg.review_request_enabled !== false} testid="cr-cfg-review-enabled" label="Demande d'avis"
            onClick={() => setCfg((c) => ({ ...c, review_request_enabled: c.review_request_enabled === false }))} />
          <div>
            <Label className="text-[10px] uppercase tracking-wider">Envoi</Label>
            <Select value={String(cfg.review_request_days_after ?? 1)} onValueChange={(v) => setCfg({ ...cfg, review_request_days_after: parseInt(v) })}>
              <SelectTrigger className="w-[190px]" data-testid="cr-cfg-review-days"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="0">Le jour du départ</SelectItem>
                <SelectItem value="1">Le lendemain du départ</SelectItem>
                <SelectItem value="2">2 jours après</SelectItem>
                <SelectItem value="3">3 jours après</SelectItem>
                <SelectItem value="7">Une semaine après</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[10px] uppercase tracking-wider">Heure (Paris)</Label>
            <Select value={String(cfg.review_request_hour ?? 11)} onValueChange={(v) => setCfg({ ...cfg, review_request_hour: parseInt(v) })}>
              <SelectTrigger className="w-[110px]" data-testid="cr-cfg-review-hour"><SelectValue /></SelectTrigger>
              <SelectContent>{HOURS.map((h) => <SelectItem key={h} value={String(h)}>{String(h).padStart(2, "0")}:00</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <div className="text-[11px] text-[#495057] mt-2">
          Le client reçoit un lien personnel pour noter son séjour (1 à 5) et commenter, une seule fois. Les avis restent privés :
          vous choisissez ceux à publier sur votre mini-site depuis <a href="/chef/avis" className="underline text-[#002FA7]" data-testid="cr-cfg-review-link">Avis clients</a>.
        </div>
      </div>
    </>
  );
}
